import { render, staticRenderFns } from "./CustomerContent.vue?vue&type=template&id=6caacbd0&scoped=true&"
import script from "./CustomerContent.vue?vue&type=script&lang=js&"
export * from "./CustomerContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContent.vue?vue&type=style&index=0&id=6caacbd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caacbd0",
  null
  
)

export default component.exports